import {Subscription} from 'rxjs';

export function RequiredInput(target: object, propertyKey: string) {
    Object.defineProperty(target, propertyKey, {
        get() {
            throw new Error(`Attribute ${propertyKey} is required`);
        },
        set(value) {
            Object.defineProperty(target, propertyKey, {value, writable: true, configurable: true});
        },
        configurable: true
    });
}


export function AutoUnsubscribe(unsubscribeMethodName = 'ngOnDestroy'): PropertyDecorator {
    return function (target: any, propertyKey: string | symbol) {
        const classConstructor = target.constructor;
        const unsubscribeMethod = classConstructor.prototype[unsubscribeMethodName];
        if (typeof unsubscribeMethod !== 'function') {
            throw new Error(classConstructor.name
                + 'is using @AutoUnsubscribe but does not implement '
                + unsubscribeMethodName);
        }
        classConstructor.prototype[unsubscribeMethodName] = function () {
            const subscriptions = this[propertyKey];
            if (!(subscriptions instanceof Array)) {
                throw new Error(classConstructor.name
                    + 'is using @AutoUnsubscribe but decorated Property is not Subscription[] but '
                    + (typeof subscriptions));
            }
            // first call original function
            if (unsubscribeMethod) unsubscribeMethod.apply(this);
            // then unsubscribe
            // important walk array from the end, so we can remove entries
            if (subscriptions && (subscriptions.length > 0)) {
                for (let index = subscriptions.length - 1; index >= 0; index--) {
                    const subscription = subscriptions[index];
                    if (subscription instanceof Subscription) {
                        subscription.unsubscribe();
                    }
                    subscriptions.splice(index, 1);
                }
            }
        };
    };
}
